import {useEffect} from "react";

export function useKeyPress(callback: (pressed: boolean) => void, keyCodes: string[]): void {
    const handler = ({code, type}: KeyboardEvent) => {
        if (type === "keyup") {
            callback(false);
            return;
        }
        callback(keyCodes.includes(code));
    };

    useEffect(() => {
        window.addEventListener("keyup", handler);
        window.addEventListener("keydown", handler)
        return () => {
            window.removeEventListener("keyup", handler);
            window.removeEventListener("keydown", handler);
        };
    }, []);
}